import { computed, inject, Injectable, ResourceRef } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { of } from "rxjs";
import { Config } from "../../../../../core/Config";
import { environment } from "../../../../../../environments/environment";
import { ApiResponse } from "../models/api-response";
import { Client } from "../../manage-banks/models/clients-models";
import { StorageService } from "src/app/core/helpers/storage.service";

const BASE_URL = environment.BASE_URL;

@Injectable({
	providedIn: "root",
})
export class ClientService {
	private config = inject(Config);
	private httpClient = inject(HttpClient);
	private storageService = inject(StorageService);

	/** @description all the clients */
	private clientsResource: ResourceRef<ApiResponse<Client[]> | undefined> = rxResource({
		stream: () => {
			const currentUser = this.storageService.getCurrentUser();
			if (currentUser && currentUser.user.userRole === "ROLE_SUPER_ADMIN") {
				return this.getClients(0, 100000);
			};
			return of<ApiResponse<Client[]>>({
				data: [],
				first: false,
				hasContent: false,
				hasNext: false,
				hasPrevious: false,
				last: false,
				numberOfElement: 0,
				pageIndex: 0,
				size: 0,
				totalElements: 0,
				totalPages: 0
			})
		},
	});

	clients = computed(() => this.clientsResource.value()?.data ?? []);
	isClientsLoading = computed(() => this.clientsResource.isLoading());

	reloadClients() {
		return this.clientsResource.reload();
	}

	getClients(pageIndex: number, pageSize: number) {
		let params = new HttpParams();
		if (pageIndex) {
			params = params.append("pageIndex", pageIndex);
		}
		if (pageSize) {
			params = params.append("pageSize", pageSize);
		}

		return this.httpClient
			.get<ApiResponse<Client[]>>(BASE_URL + this.config.getClients, { params });
	}

	getCLientByClientCodeOrCLientName(searchParams) {
		let params = new HttpParams();
		if (searchParams.clientCode || searchParams.clientName) {
			params = params.append("clientCode", searchParams.clientCode)
				.append("clientName", searchParams.clientName);
		}

		return this.httpClient.get(BASE_URL + this.config.getClientByClientCodeOrClientName, { params })
			.pipe(
				map((client) => {
					return client;
				})
			)
	}

	createClient(clientDetails: FormData) {
		return this.httpClient.post(BASE_URL + this.config.createClient, clientDetails);
	}
	updateClient(clientDetails: FormData, clientId: number) {
		return this.httpClient.post(BASE_URL + this.config.updateClient + "/" + clientId, clientDetails);
	}
	updateClientDetails(clientDetails: Object) {
		return this.httpClient.post(BASE_URL + this.config.updateClientDetails, clientDetails);
	}
	deleteClient(code: string) {
		return this.httpClient.post(BASE_URL + this.config.deleteClient + code, {});
	}
	disableCLient(clientCode) {
		let params = new HttpParams();
		if (clientCode) {
			params = params.append("clientCode", clientCode);
		}
		return this.httpClient.patch(BASE_URL + this.config.disableClient, "/", { params });
	}
	enableClient(clientCode: string) {
		let params = new HttpParams();
		if (clientCode) {
			params = params.append("clientCode", clientCode);
		}
		return this.httpClient.patch(BASE_URL + this.config.enableClient, "/", { params });
	}
}
